module.exports = __webpack_public_path__ + "img/step1.230c4b9b.svg";